import React, { useState } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import ROUTES from 'constants/routes'
import Logo from 'assets/icons/logo.png'
import MenuIcon from 'assets/icons/menu.png'
import CloseIcon from 'assets/icons/close.png'
import MenuLanding from './MenuLanding'
import DropDown from './DropDown'

function Header() {
  const { t } = useTranslation()

  const [showMenu, setShowMenu] = useState(false)

  const show = () => setShowMenu(true)
  const hide = () => setShowMenu(false)

  return (
    <div>
      <div className={showMenu ? 'header header--menu-open' : 'header'}>
        <Link to={ROUTES.LANDING_HOME} onClick={() => hide()}>
          <img src={Logo} alt="The Rivals" className="header__logo header__container__logo" />
        </Link>
        <div className="header__container-menu">
          {showMenu ? (
            <button className="btn header__menu" type="button" onClick={hide}>
              <img src={CloseIcon} alt="menu" className="menu__btn-img" />
            </button>
          ) : (
            <button className="btn header__menu" type="button" onClick={show}>
              <img src={MenuIcon} alt="menu" className="menu__btn-img" />
            </button>
          )}
        </div>
        <div className="header__list">
          <div className="header__item">
            <NavLink exact to={ROUTES.LANDING_HOME} className="header__link">
              {t('landing.header.home')}
            </NavLink>
          </div>
          <div className="header__item">
            <NavLink exact to={ROUTES.LANDING_GAME_OVERVIEW} className="header__link">
              {t('landing.header.game_overview')}
            </NavLink>
          </div>
          <div className="header__item">
            <NavLink exact to={ROUTES.LANDING_ABOUT} className="header__link">
              {t('landing.header.about')}
            </NavLink>
          </div>
        </div>
        <DropDown variant="desktop" />
      </div>
      {showMenu && <MenuLanding hideMenu={hide} />}
    </div>
  )
}

export default Header
